






import { Component, Mixins } from "vue-property-decorator";

// Mixin
import { WidgetMixin, GroupMixin, LayoutMixin } from "./mixins";

@Component({
  components: {
    WidgetGroup: () => import("@/components/WidgetGroup.vue")
  }
})
export default class WGroup extends Mixins(
  WidgetMixin,
  LayoutMixin,
  GroupMixin
) {}
